// src/components/CustomersModal.jsx
import React, { useEffect, useMemo, useState } from 'react'

const CustomersModal = ({
  open,
  onClose,
  onSave,
  customers = [],
  initialSelected = [],
  title = 'Seleccionar clientes'
}) => {
  const [localSelected, setLocalSelected] = useState(new Set(initialSelected))
  const [search, setSearch] = useState('')

  useEffect(() => {
    // Keep modal state in sync when opened with new defaults
    if (open) {
      setLocalSelected(new Set(initialSelected))
      setSearch('')
    }
  }, [open, initialSelected])

  const filtered = useMemo(() => {
    const s = search.trim().toLowerCase()
    const source = customers
      .filter(c => c.Type === 'GENERAL' || c.Type === 'LICENCIA_BASICA' || c.Type === 'LICENCIA_PRO')
      .sort((a, b) => a.Fullname.localeCompare(b.Fullname))
    if (!s) return source
    return source.filter(c => (c.Fullname || '').toLowerCase().includes(s))
  }, [customers, search])

  const toggle = (id) => {
    const next = new Set(localSelected)
    if (next.has(id)) next.delete(id)
    else next.add(id)
    setLocalSelected(next)
  }

  const selectAll = () => {
    setLocalSelected(new Set(filtered.map(c => c._id)))
  }
  const unselectAll = () => setLocalSelected(new Set())

  if (!open) return null

  return (
    <div className="vw-modal">
      <div className="vw-modal__backdrop" onClick={onClose} />
      <div className="vw-modal__dialog">
        <div className="vw-modal__header">
          <h5 className="m-0">{title}</h5>
          <button type="button" className="close" onClick={onClose} aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div className="vw-modal__body">
          <div className="d-flex mb-2">
            <input
              className="form-control"
              placeholder="Buscar cliente…"
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
          </div>

          <div className="d-flex mb-2">
            <button type="button" className="btn btn-sm btn-outline-secondary mr-2" onClick={selectAll}>
              Seleccionar todo
            </button>
            <button type="button" className="btn btn-sm btn-outline-secondary" onClick={unselectAll}>
              Deseleccionar todo
            </button>
            <div className="ml-auto small text-muted align-self-center">
              {localSelected.size} seleccionado(s)
            </div>
          </div>

          <div className="vw-modal__list">
            {filtered.map(c => (
              <label key={c._id} className="vw-modal__item">
                <input
                  type="checkbox"
                  className="mr-2"
                  checked={localSelected.has(c._id)}
                  onChange={() => toggle(c._id)}
                />
                {c.Fullname}
              </label>
            ))}
            {filtered.length === 0 && (
              <div className="text-muted">No hay resultados.</div>
            )}
          </div>
        </div>

        <div className="vw-modal__footer">
          <button type="button" className="btn btn-light" onClick={onClose}>Cancelar</button>
          <button
            type="button"
            className="btn bg-vw-dark text-white"
            onClick={() => onSave(Array.from(localSelected))}
          >
            Guardar selección
          </button>
        </div>
      </div>

      {/* Minimal styles so it works without Bootstrap JS */}
      <style jsx>{`
        .vw-modal {
          position: fixed; inset: 0; z-index: 1050; display: flex; align-items: center; justify-content: center;
        }
        .vw-modal__backdrop {
          position: absolute; inset: 0; background: rgba(0,0,0,.45);
        }
        .vw-modal__dialog {
          position: relative; width: 720px; max-width: 92vw; max-height: 86vh; background: #fff; border-radius: .5rem; overflow: hidden; display: flex; flex-direction: column;
          box-shadow: 0 10px 30px rgba(0,0,0,.2);
        }
        .vw-modal__header, .vw-modal__footer {
          padding: .75rem 1rem; border-bottom: 1px solid #eee;
        }
        .vw-modal__footer { border-top: 1px solid #eee; border-bottom: 0; display: flex; justify-content: flex-end; gap: .5rem; }
        .vw-modal__body { padding: 1rem; overflow: auto; }
        .vw-modal__list { max-height: 50vh; overflow: auto; border: 1px solid #eee; border-radius: .25rem; padding: .5rem; }
        .vw-modal__item { display: flex; align-items: center; padding: .375rem .25rem; margin: 0; cursor: pointer; user-select: none; }
        .vw-modal__item:hover { background: #fafafa; }
      `}</style>
    </div>
  )
}

export default CustomersModal
